import type { Transaction } from '@shared/transactions-types';

import { formatStatement } from './formatStatement';

export function getStatement({ billId }: Transaction): string {
    if (billId) {
        const billIdString = String(billId);

        return formatStatement(billIdString);
    }
    return '';
}
